<template>
  <fragment>
    <b-modal
      :id="modalID"
      size="lg"
      hide-header
      hide-footer
      @hide="closeModal"
      @hidden="onModalHidden"
      :noCloseOnEsc="isPublishing"
      :noCloseOnBackdrop="isPublishing"
    >
        <div
          :id="`close-${modalID}`"
          type="button"
          aria-label="Close"
          @click="closeModal()"
        >
          <i class="fal fa-times" v-if="!isPublishing"></i>
        </div>

        <div class="content-publishing" v-if="isPublishing">
          <div class="title">{{ $t('engine.modal.publishing.lblTitle') }}</div>
          <div class="desc">{{ $t('engine.modal.publishing.lblDescription') }}</div>
          <div class="icon-website my-gd-2"> 
            <img :src="require('@assets/images/publish.png')" height="130"/>
          </div>
          <b-progress
            class="mt-gd-3 mb-gd-2 mx-gd-1"
            variant="primary"
            :height="'20px'"
            striped
            :show-value="true"
            :animated="true"
          >
            <b-progress-bar :value="publishPercent" :label="`${publishPercent}%`"></b-progress-bar>
          </b-progress>
          <div class="info my-gd-2">{{ $t('engine.modal.publishing.lblMessage') }}</div>
        </div>

        <div class="content-published" v-else>
          <div class="title">{{ $t('engine.modal.publish.lblTitle') }}</div>
          <div class="desc">{{ $t('engine.modal.publish.lblDescription') }}</div>
          <div class="icon-website my-gd-2"> 
            <img :src="require('@assets/images/publish.png')" height="130"/>
          </div>
          <div class="domian-container mt-gd-2 mx-gd-1">
            <div class="domian-wrap">
              <div class="icon-domain"><i class="fas fa-arrow-right"></i></div>
              <div class="icon-domain"><i class="fas fa-redo"></i></div>
              <div class="input-domain">
                <div>{{domain}}</div>
              </div>
            </div>
            <div class="btn-view-site">
              <b-button size="lg" variant="primary" @click="viewSite">{{ $t('engine.modal.publish.btnView') }}</b-button>
            </div>
          </div>
          <div class="info my-gd-2">{{ $t('engine.modal.publish.lblMessage') }}</div>
        </div>

    </b-modal>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      modalID: "modal-publish",
      render: true,
    };
  },
  computed: {
    ...mapGetters({
      domains: "design/site/domains",
      modalActive: "design/modals/modalActive",
      languageUse: "design/site/languageUse",
      languageDefault: "design/site/languageDefault",
      publishStatus: "design/page/publishStatus",
    }),
    domain() {
      return 'https://' + this.domains.main + (this.languageUse == this.languageDefault ? '' : '/' + this.languageUse)
    },
    isPublishing() {
      return this.publishStatus.status !== "published";
    },
    publishPercent() {
      return (this.publishStatus && this.publishStatus.progress && this.publishStatus.progress.percent) || 0;
    }
  },
  methods: {
    openModal() {
      this.$bvModal.show(this.modalID);
    },
    async closeModal() {
      this.$store.dispatch("design/modals/callback", {
        key: this.modalID,
        clear : true,
        func : 'cancel',
        data : {}
      }, { root:true });
      this.$bvModal.hide(this.modalID);
    },
    onModalHidden() {
      this.$store.dispatch("design/modals/callback", {
        key: this.modalID,
        clear: true,
        func: 'onClose',
        data: {}
      },{ root:true });
    },
    viewSite() {
      window.open(this.domain)
      this.closeModal()
    }
  },
  beforeDestroy() {
    this.$store.dispatch("design/modals/callback", {
      key: this.modalID,
      clear: true,
      func: 'onClose',
      data: {}
    },{ root:true });
  },
  watch: {
    modalActive: {
      handler(next) {
        if (next == this.modalID) {
          this.openModal();
        }
      },
    },
  },
};
</script>

<style lang="scss">
#modal-publish {
  .modal-dialog {
    width: 600px;
  }
  .modal-body {
    padding: 15px 20px;
    #close-modal-publish {
      font-size: 25px;
      height: 16px;
      position: relative;
      svg {
        position: absolute;
        right: 0;
        top: -5px;
      }
    }
    .title {
      font-family: 'MWE_DB_Heavent';
      font-style: normal;
      font-weight: 700;
      font-size: 40px;
      line-height: 40px;
      text-align: center;
      color: #373E44;
    }
    .desc {
      margin-top: 5px;
      font-family: 'Sarabun';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #53585D;
    }
    .icon-website {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .content-publishing {
      .icon-website {
        opacity: 0.3;
      }
    }
    .domian-container {
      display: flex;
      align-items: center;
      .domian-wrap {
        display: flex;
        flex-grow: 1;
        align-items: center;
        padding: 8px 30px 8px 10px;
        gap: 8px;
        background: #E8ECEF;
        border-radius: 4px;
        .icon-domain {
          color: #84929F;
        }
        .input-domain {
          width: 100%;
          padding: 2px 16px 3px;
          background: #FFFFFF;
          border-radius: 20px;
          font-family: 'Sarabun';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #53585D;
        }
      }
      .btn-view-site {
        margin-left: 15px;
      }
    }
    .info {
      font-family: 'Sarabun';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      color: #84929F;
    }
  }
}
</style>
